import { Box } from '@chakra-ui/react'
import { LocaleProvider } from '@/i18n'
import {
  Nav,
  Hero,
  CompanyLogos,
  Services,
  WhereAIPaysOff,
  PainPoints,
  Mission,
  HowWeWork,
  CaseStudies,
  About,
  Contact,
  Footer,
} from '@/components/sections'

const App = () => (
  <LocaleProvider>
    <Box as="main" minH="100vh" bg="ground" color="ink">
      <Nav />
      <Hero />
      <CompanyLogos />
      <Services />
      <WhereAIPaysOff />
      <PainPoints />
      <Mission />
      <HowWeWork />
      <CaseStudies />
      <About />
      <Contact />
      <Footer />
    </Box>
  </LocaleProvider>
)

export default App
